export const IS_FEMALE = process.env.REACT_APP_IS_FEMALE === "true";
